<template>
  <div
    :class="[
      'gfb-radio-container',
      { required: required },
      { 'pill-error': !!error },
    ]"
  >
    <p v-if="label" class="w-100 font-16-500 mb-2">
      {{ label }}{{ required ? " *" : "" }}
    </p>
    <span v-if="subtitle" class="w-100 mb-2 d-block">{{ subtitle }}</span>
    <div class="d-flex flex-wrap">
      <radio-input
        v-for="opt in normalizedOptions"
        :key="opt.inputId"
        type="checkbox"
        :inputId="opt.inputId"
        :name="name"
        :value="opt.value"
        :checked="(value || []).includes(opt.value)"
        :label="opt.text"
        :disabled="disabled"
        @change="handleChange(opt.value)"
      />
    </div>
    <form-error nonInput v-if="error">{{ error }}</form-error>
  </div>
</template>

<script>
export default {
  name: "gfb-checkbox-group",
  props: {
    label: { type: String, default: "" },
    name: { type: String, required: true },
    options: { type: Array, required: true },
    value: { type: Array, default: () => [] },
    required: { type: Boolean, default: false },
    error: { default: null },
    subtitle: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  emits: ["change"],
  computed: {
    normalizedOptions() {
      return this.options.map((opt) => {
        if (typeof opt === "object" && opt !== null) {
          return {
            text: opt.text ?? String(opt.value),
            value: opt.value,
            inputId: `${this.name}-${opt.text ?? opt.value}`,
          }
        }
        return { text: String(opt), value: opt, inputId: `${this.name}-${opt}` }
      })
    },
  },
  methods: {
    handleChange(val) {
      if (this.disabled) return
      const current = this.value || []
      const next = current.includes(val)
        ? current.filter((v) => v !== val)
        : [...current, val]
      this.$emit("change", next)
    },
  },
}
</script>
